import styled from 'styled-components';

export const ButtonStyled = styled.div`
  button {
    width: 21.428rem;
    height: 4.428rem;
    background: #2a6fdb 0% 0% no-repeat padding-box;
    border-radius: 35px;
    font-size: 1.285rem;
  }
`;
